import { DVRInfo } from "../types";

/**
 * Checks if the target time is behind the DVR window.
 */
export const isBehindDVRWindow = (targetTime: number, dvrWindow: DVRInfo) => {
  const availableFrom = dvrWindow.manifestInfo.availableFrom.getTime();
  return targetTime < availableFrom;
};
